import styled from "@emotion/styled";

const StyledSearchAutocomplete = styled.div`
  display: flex;
  flex-direction: column;

  ld-icon {
    --ld-input-icon-col: var(--ld-col-neutral-999);
    cursor: pointer;
  }

  ld-input::part(input focusable) {
    font: var(--ld-typo-body-m);
  }
`;

export { StyledSearchAutocomplete };
